import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { isAbleToShowCashColumn } from "./CashCellRenderer";
import {
  determineDealerFromImpliedValues,
  shouldRenderDealerCell,
} from "./DealerCellRenderer";

// LQC-2216: "dealer" is a front-end only field, so copy/paste needs the same value the renderer shows.
export function formatDealerForCopy(params: any): string {
  if (!params.data) {
    return "";
  }

  const { isOp, isLeg, isER, isOutright, fullTradeData } =
    returnAllTradeDetailsFromGenericParams(params);

  const thisTrade =
    tradeDataStore
      .getState()
      .tradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  if (!thisTrade) {
    return "";
  }

  if (!shouldRenderDealerCell(params, fullTradeData.unwind, isLeg, isOutright)) {
    return "";
  }

  if (
    !isAbleToShowCashColumn({ params, thisTrade, isOp, isLeg, isER, isOutright })
  ) {
    return "";
  }

  const dealer = determineDealerFromImpliedValues(params, thisTrade, isOutright);
  return dealer ? `Dealer ${dealer}` : "";
}

// AG Grid valueFormatter for the Unwind Amount direction column.
export function dealerCellValueFormatter(params: any): string {
  return formatDealerForCopy(params);
}
